import Rays from './Rays';
import { useStore } from '@immutabl3/store/react';
import { EffectComposer } from '@react-three/postprocessing';

export default {
  before() {
    const [sun] = useStore(['references', 'dysonsun']) ?? [];
    const [camera] = useStore(['references', 'dysoncamera']) ?? [];
    
    if (!sun?.current) return null;
    if (!camera?.current) return null;
    
    return (
      <EffectComposer>
        <Rays sun={ sun } camera={ camera } />
      </EffectComposer>
    );
  },
};